export default __webpack_public_path__ + "b0e46af879445424af3b171286eb7ec8.png";